import React, { useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './TestimonialSlider.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

const TestimonialSlider = () => {
  const testimonials = [
    {
      id: 1,
      description: '"This machine is excellent. It occupies less space, affordable and I can use it gym as sanitizer machine or soap Dispenser."',
      image: 'images/home_img/user.png',
      name: 'Prashanth, Gym Owner',
      subtitle: 'Mumbai, India',
    },
    // {
    //   id: 2,
    //   description: '" This machine is excellent. It occupies less space, affordable and I can use it gym as sanitizer machine or soap Dispenser. "',
    //   image: 'images/home_img/user.png',
    //   name: 'Shariq Ahmed',
    //   subtitle: 'Hyderabad, India',
    // },
    // {
    //   id: 3,
    //   description: '" This machine is excellent. It occupies less space, affordable and I can use it gym as sanitizer machine or soap Dispenser. "',
    //   image: 'images/home_img/user.png',
    //   name: 'Doe John',
    //   subtitle: 'Florida, USA',
    // },
  ];

  const [activeCard, setActiveCard] = useState(0);

  const handlePrevCard = () => {
    setActiveCard((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNextCard = () => {
    setActiveCard((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="testimonial-slider">
      <h1 className='testimonial-heading'>Testimonials</h1>
      <div className="testimonial-row">
        <div className="testimonial-title">
          <p>What People Say{"\n"}About 'Untouched'{"\n"}Device.</p>
        </div>
        <div className="testimonial-carousel">
          <Carousel
            showStatus={false}
            showIndicators={false}
            showArrows={false}
            showThumbs={false}
            autoPlay
            infiniteLoop
            interval={5000}
            transitionTime={500}
            selectedItem={activeCard}
            onChange={(selectedIndex) => setActiveCard(selectedIndex)}
          >
            {testimonials.map((testimonial) => (
              <div className="testimonial-card" key={testimonial.id}>
                <div className="testimonial-content">
                  <div className="testimonial-description">
                    <p>{testimonial.description}</p>
                  </div>

                  <div className="testimonial-user">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="user-image"
                    />
                    <div className="testimonial-details">
                      <h3 className="testimonial-name">{testimonial.name}</h3>
                      <p className="testimonial-subtitle">{testimonial.subtitle}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Carousel>
        </div>
        <div className="testimonial-controls">
          <button className="arrow-button" onClick={handlePrevCard}>
            <i className="fas fa-chevron-up"></i>
          </button>
          <button className="arrow-button" onClick={handleNextCard}>
            <i className="fas fa-chevron-down"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default TestimonialSlider;
